import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCalendarMonth = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	fill: "none",
	stroke: "currentColor",
	strokeLinecap: "round",
	strokeLinejoin: "round",
	width: 20,
	height: 20,
	strokeWidth: 1.5,
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", { d: "M4 7a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v12a2 2 0 0 1 -2 2h-12a2 2 0 0 1 -2 -2v-12z" }),
		/* @__PURE__ */ _jsx("path", { d: "M16 3v4" }),
		/* @__PURE__ */ _jsx("path", { d: "M8 3v4" }),
		/* @__PURE__ */ _jsx("path", { d: "M4 11h16" }),
		/* @__PURE__ */ _jsx("path", { d: "M7 14h.013" }),
		/* @__PURE__ */ _jsx("path", { d: "M10.01 14h.005" }),
		/* @__PURE__ */ _jsx("path", { d: "M13.01 14h.005" }),
		/* @__PURE__ */ _jsx("path", { d: "M16.015 14h.005" }),
		/* @__PURE__ */ _jsx("path", { d: "M13.015 17h.005" }),
		/* @__PURE__ */ _jsx("path", { d: "M7.01 17h.005" }),
		/* @__PURE__ */ _jsx("path", { d: "M10.01 17h.005" })
	]
});
const ForwardRef = forwardRef(SvgCalendarMonth);
export default ForwardRef;
